import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import Question from '../Question/Question';
import {
  isHtmlSelector,
  selectedQuestionSelector,
} from '../../store/selectors';
import PostMessageForm from '../PostMessageForm/PostMessageForm';
import { questionOpenStateId } from '../../constants/common';
import styles from './QuestionBox.module.scss';

const QuestionBox = ({ className }) => {
  return (
    <Container className={className}>
      <Question className={styles.question} />
    </Container>
  );
};

export default QuestionBox;

function Container({ children, className }) {
  const selectedQuestion = useSelector(selectedQuestionSelector);
  const isHtml = useSelector(isHtmlSelector);

  const messagesEndRef = useRef();

  const handleAddMsgSuccess = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const shouldRenderForm =
    selectedQuestion?.stateId === questionOpenStateId && !isHtml;

  return (
    <div className={cn(styles.root, className)}>
      {children}
      <div ref={messagesEndRef} />
      {shouldRenderForm && (
        <PostMessageForm
          className={styles.form}
          onAddMsgSuccess={handleAddMsgSuccess}
        />
      )}
    </div>
  );
}
